// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"styles_searchInput__2ajR_","companySelect":"styles_companySelect__MdF5Y"};